import React, { useEffect, useState, useRef } from 'react';
import Plot from 'react-plotly.js';
import Plotly from 'plotly.js-basic-dist';
import '../assets/styles/BarPlot.css'
import { useAuth } from './Auth/AuthContext';
import { API_BASE_URL } from '../config/api';


const AttendanceBarPlot = ({ month, year }) => {
  const [visData, setVisData] = useState([]);
  const { token } = useAuth();

  const monthArr = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  useEffect(() => {
    const formatDate = (dateStr) => {
      const [year, month, day] = dateStr.split('-');
      return `${month}-${day}-${year}`
    }

    const fetchSessionCounts = async () => {
      try {
        const monthIndex = monthArr.indexOf(month) + 1;

        const sessionResponse = await fetch(`${API_BASE_URL}/attendance/sessions/year/${year}/month/${monthIndex}`, {
          'headers': {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!sessionResponse.ok) {
          throw new Error(`Could not fetch sessions for ${month} ${year}`);
        }
        const sessions = await sessionResponse.json();

        const sessionCounts = await Promise.all(sessions.map(async (session) => {
          try {
            const response = await fetch(`${API_BASE_URL}/attendance/sessions/${session.SessionID}`, {
              'headers': {
                'Authorization': `Bearer ${token}`
              }
            });
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

            const data = await response.json();
            return {
              // date: new Date(session.Date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
              date: formatDate(session.Date),
              count: data.length
            };
          } catch (error) {
            console.error(`Error fetching session with sessionID ${session.SessionID}`, error);
            return {
              // date: new Date(session.Date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
              date: formatDate(session.Date),
              count: 0
            };
          }
        }));

        setVisData(sessionCounts);
      } catch (err) {
        console.error('Error fetching attendance chart data:', err);
        setVisData([]);
      }
    };

    fetchSessionCounts();
  }, [month, year]);

  const handleResize = (figure, div) => {
    if (div) {
      Plotly.Plots.resize(div);
    }
  };

  if (visData.length === 0) return null;

  return (
    <div className='plot-container'>
      <Plot
        data={[{
          type: 'bar',
          x: visData.map(bar => bar.date),
          y: visData.map(bar => bar.count),
          text: visData.map(bar => `${bar.count} attendees`),
          textposition: 'none',
          hovertemplate: '%{x}<br>%{text}<extra></extra>',
          marker: {
            color: 'rgba(0, 123, 255, 0.7)',
            line: { color: '#87c7eb', width: 1.5 }
          },
        }]}
        layout={{
          autosize: true,
          height: 350,
          title: {
            text: `Attendance Summary: ${month} ${year}`,
            font: { size: 24 }
          },
          xaxis: {
            title: 'Session Date',
            tickfont: { size: 14 }
          },
          yaxis: {
            title: 'Number of Attendees',
            tickfont: { size: 14 }
          },
          bargap: 0.3,
          plot_bgcolor: 'white',
          paper_bgcolor: 'white',
          font: { family: 'Arial, sans-serif' },
          hoverlabel: {
            bgcolor: '#f8f9fa',
            bordercolor: '#ccc',
            font: { color: '#212529' }
          }
        }}
        config={{ responsive: true }}
        onInitialized={handleResize}
        onUpdate={handleResize}
      />
    </div>
  );
};

export default AttendanceBarPlot;
